import * as fromDatatype from '../datatype-library/index';

export interface bl_sys_provider_login_subject_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  dev_app_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_sys_provider_login_subject_link_RowClass implements bl_sys_provider_login_subject_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  dev_app_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

